import React from 'react';

const ErrorMessage = ({ message, className = '' }) => {
  if (!message) return null;
  return (
    <div className={`bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative my-4 text-center shadow ${className}`} role="alert">
      <span className="block sm:inline font-semibold">Error: </span>
      <span className="block sm:inline">{message}</span>
    </div>
  );
};

export default ErrorMessage; 